"use client";

import { ProductDetails } from "@/sdk/types";
import React, { useState, useEffect } from "react";

interface Variant {
  color: string;
  product: ProductDetails; // This is the product ID/handle
}

interface VariantSelectionData {
  variants: Variant[];
}

// Sample data object for initial development
// Assuming ProductDetails is defined elsewhere, or define a basic type here
// This should match the structure returned by window.helium.datastore.getProduct().details
const VariantSelection: React.FC<{
  variantData: Variant[];
}> = ({ variantData }) => {
  return (
    <div className="variant-selection-container hp-hidden">
      {variantData.length > 0 && (
        <div style={{ display: "flex", gap: "10px" }}>
          {variantData.map((variant, index) => {
            const product = variant.product;
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    border: "1px solid black",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    overflow: "hidden", // Hide overflow if image is larger
                  }}
                >
                  {product?.featuredImage?.url ? (
                    <img
                      src={product.featuredImage.url}
                      alt={`Variant ${variant.color}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover", // Cover the box while maintaining aspect ratio
                      }}
                    />
                  ) : (
                    // Placeholder for image or cross if no image
                    <div
                      style={{
                        fontSize: "30px",
                        lineHeight: "50px",
                        textAlign: "center",
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        top: 0,
                        left: 0,
                      }}
                    >
                      &times;
                    </div>
                  )}
                </div>
                <span style={{ fontSize: "12px", marginTop: "5px" }}>
                  {variant.color}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default VariantSelection;
